export default __webpack_public_path__ + "static/media/Ambient, Red.e742b643.png";